var _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _path6, _rect6, _path7, _path8, _path9, _rect7, _path10, _path11, _rect8, _path12, _rect9, _rect10, _path13, _path14, _path15, _rect11, _path16, _path17, _rect12, _path18, _rect13, _path19, _path20, _path21, _path22, _path23, _path24, _rect14, _path25, _path26, _path27, _path28;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreenchimentoInfosVideochamada = function SvgPreenchimentoInfosVideochamada(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 168,
    viewBox: "0 0 348 168",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 8C95 3.58172 98.5817 0 103 0H245C249.418 0 253 3.58172 253 8V160C253 164.418 249.418 168 245 168H103C98.5817 168 95 164.418 95 160V8Z",
    fill: "#C5D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 8C95 3.58172 98.5817 0 103 0H245C249.418 0 253 3.58172 253 8V16H95V8Z",
    fill: "#F2F2F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 24,
    width: 142,
    height: 136,
    rx: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 12C109.209 12 111 10.2091 111 8C111 5.79086 109.209 4 107 4C104.791 4 103 5.79086 103 8C103 10.2091 104.791 12 107 12Z",
    fill: "#C5D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 12C121.209 12 123 10.2091 123 8C123 5.79086 121.209 4 119 4C116.791 4 115 5.79086 115 8C115 10.2091 116.791 12 119 12Z",
    fill: "#84AAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131 12C133.209 12 135 10.2091 135 8C135 5.79086 133.209 4 131 4C128.791 4 127 5.79086 127 8C127 10.2091 128.791 12 131 12Z",
    fill: "#002451"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 4,
    width: 102,
    height: 8,
    rx: 2,
    fill: "#C5D4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 70.5,
    width: 133,
    height: 85,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 70.5,
    width: 133,
    height: 85,
    rx: 1.5,
    stroke: "#C5D4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 61.8834,
    height: 8.88336,
    transform: "translate(113 66)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.942 70.4417H170.942",
    stroke: "#8F8FA2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 88,
    width: 122,
    height: 12,
    rx: 2,
    stroke: "#498FFF",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115 81.5H159",
    stroke: "#C5D4FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M223 87.5H233.5C234.605 87.5 235.5 88.3954 235.5 89.5L235.5 98.5C235.5 99.6046 234.605 100.5 233.5 100.5H223L223 87.5Z",
    fill: "#84AAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.254 92.2014C231.301 92.153 231.357 92.1144 231.418 92.0879C231.48 92.0613 231.547 92.0474 231.614 92.0468C231.681 92.0462 231.748 92.059 231.81 92.0845C231.873 92.1099 231.929 92.1476 231.977 92.1951C232.024 92.2427 232.062 92.2992 232.087 92.3615C232.113 92.4238 232.126 92.4905 232.125 92.5577C232.124 92.625 232.11 92.6915 232.084 92.7533C232.057 92.8151 232.019 92.871 231.97 92.9177L229.437 95.4506C229.342 95.5455 229.214 95.5989 229.079 95.5989C228.945 95.5989 228.816 95.5455 228.721 95.4506L226.188 92.9177C226.093 92.8227 226.039 92.6939 226.039 92.5595C226.039 92.4929 226.052 92.427 226.078 92.3656C226.103 92.3041 226.141 92.2482 226.188 92.2011C226.235 92.1541 226.29 92.1167 226.352 92.0913C226.413 92.0658 226.479 92.0526 226.546 92.0526C226.68 92.0526 226.809 92.1059 226.904 92.2009L229.079 94.3761L231.254 92.2014Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 116,
    width: 122,
    height: 12,
    rx: 2,
    stroke: "#498FFF",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223 115.5H233.5C234.605 115.5 235.5 116.395 235.5 117.5L235.5 126.5C235.5 127.605 234.605 128.5 233.5 128.5H223L223 115.5Z",
    fill: "#84AAFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.254 120.202C231.301 120.153 231.357 120.115 231.418 120.088C231.48 120.061 231.547 120.047 231.614 120.047C231.681 120.046 231.748 120.059 231.81 120.085C231.873 120.11 231.929 120.148 231.977 120.195C232.024 120.243 232.062 120.299 232.087 120.362C232.113 120.424 232.126 120.491 232.125 120.558C232.124 120.625 232.11 120.692 232.084 120.753C232.057 120.815 232.019 120.871 231.97 120.918L229.437 123.451C229.342 123.546 229.214 123.599 229.079 123.599C228.945 123.599 228.816 123.546 228.721 123.451L226.188 120.918C226.093 120.823 226.039 120.694 226.039 120.56C226.039 120.493 226.052 120.427 226.078 120.366C226.103 120.304 226.141 120.248 226.188 120.201C226.235 120.154 226.29 120.117 226.352 120.091C226.413 120.066 226.479 120.053 226.546 120.053C226.68 120.053 226.809 120.106 226.904 120.201L229.079 122.376L231.254 120.202Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 141.5,
    width: 10,
    height: 10,
    rx: 2,
    stroke: "#84AAFF",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129 147.5H167",
    stroke: "#C5D4FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 53,
    width: 10,
    height: 10,
    rx: 5,
    stroke: "#84AAFF",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 53,
    width: 10,
    height: 10,
    rx: 5,
    stroke: "#84AAFF",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123 58.5H155",
    stroke: "#C5D4FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179 58.5H211",
    stroke: "#C5D4FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47.5H142",
    stroke: "#8F8FA2",
    strokeWidth: 3.94168,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 24,
    width: 142,
    height: 16,
    rx: 2,
    fill: "#F0F0F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127 32.5H207",
    stroke: "#8F8FA2",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.211 33.1279C235.173 33.1677 235.127 33.1994 235.076 33.2212C235.025 33.2431 234.97 33.2546 234.915 33.2551C234.86 33.2555 234.805 33.245 234.754 33.224C234.703 33.2031 234.656 33.1722 234.617 33.133C234.578 33.0939 234.547 33.0474 234.526 32.9962C234.505 32.945 234.494 32.8901 234.495 32.8348C234.495 32.7795 234.507 32.7248 234.529 32.6739C234.551 32.6231 234.582 32.5771 234.622 32.5387L236.705 30.4554C236.784 30.3773 236.89 30.3334 237 30.3334C237.11 30.3334 237.216 30.3773 237.295 30.4554L239.378 32.5391C239.454 32.6177 239.496 32.723 239.495 32.8322C239.494 32.9415 239.451 33.046 239.373 33.1232C239.296 33.2005 239.191 33.2443 239.082 33.2452C238.973 33.2462 238.868 33.2042 238.789 33.1283L237 31.3391L235.211 33.1279Z",
    fill: "#696979"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 23.9999,
    width: 16,
    height: 16,
    rx: 0.6,
    fill: "#696979"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.833 32C106.833 29.6988 108.699 27.8334 111 27.8334C113.301 27.8334 115.167 29.6988 115.167 32C115.167 34.3009 113.301 36.1667 111 36.1667C108.699 36.1667 106.833 34.3009 106.833 32ZM112.372 30.4555L110.167 32.6609L109.211 31.705C109.173 31.6652 109.127 31.6335 109.076 31.6117C109.025 31.5898 108.97 31.5783 108.915 31.5779C108.86 31.5774 108.805 31.5879 108.754 31.6089C108.702 31.6298 108.656 31.6608 108.617 31.6999C108.578 31.739 108.547 31.7855 108.526 31.8367C108.505 31.8879 108.494 31.9428 108.495 31.9981C108.495 32.0534 108.507 32.1081 108.529 32.159C108.55 32.2098 108.582 32.2558 108.622 32.2942L109.872 33.5446C109.951 33.6227 110.057 33.6666 110.167 33.6666C110.277 33.6666 110.383 33.6227 110.462 33.5446L112.962 31.0446C113.001 31.0062 113.033 30.9602 113.055 30.9094C113.077 30.8585 113.088 30.8039 113.089 30.7485C113.089 30.6932 113.079 30.6384 113.058 30.5871C113.037 30.5359 113.006 30.4894 112.967 30.4503C112.928 30.4112 112.881 30.3802 112.83 30.3593C112.779 30.3383 112.724 30.3278 112.669 30.3283C112.613 30.3288 112.559 30.3402 112.508 30.3621C112.457 30.3839 112.411 30.4157 112.372 30.4555Z",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 20,
    width: 156,
    height: 32,
    rx: 4.39437,
    fill: "#FF8C54",
    stroke: "#E76F00",
    strokeWidth: 1.09859,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.3 3.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M229 28.5H331",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M229 35.5H331",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M229 42.5H297",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204 28H203C201.667 28 201 28.668 201 30.004V32H212.354C213.059 31.3776 213.986 31 215 31C215.729 31 216.412 31.1948 217 31.5351V30C217 28.667 216.333 28 215 28H214V26.941C214 26.314 213.667 26 213 26C212.333 26 212 26.314 212 26.941V28H206.004V27C206.004 26.333 205.67 26 205 26C204.33 26 203.998 26.333 204 27V28Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.126 34H201V44C201 45.333 201.667 46 203 46H211.126C211.044 45.6804 211 45.3453 211 45V44H210C208.969 44 208.029 43.6099 207.32 42.9693C207.223 42.9898 207.117 43 207 43H206C205.333 43.001 205 42.668 205 42C205.001 41.332 205.335 40.999 206.002 41H206.126C206.044 40.6804 206 40.3453 206 40C206 39.6547 206.044 39.3196 206.126 39H206C205.333 39.001 205 38.668 205 38C205.001 37.332 205.335 36.999 206.002 37H207C207.117 37 207.223 37.0102 207.32 37.0307C208.029 36.3901 208.969 36 210 36H211V35C211 34.6547 211.044 34.3196 211.126 34Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214 35C214 34.4477 214.448 34 215 34C215.552 34 216 34.4477 216 35V39H220C220.552 39 221 39.4477 221 40C221 40.5523 220.552 41 220 41H216V45C216 45.5523 215.552 46 215 46C214.448 46 214 45.5523 214 45V41H210C209.448 41 209 40.5523 209 40C209 39.4477 209.448 39 210 39H214V35Z",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 104,
    width: 156,
    height: 32,
    rx: 4.39437,
    fill: "#FF8C54",
    stroke: "#E76F00",
    strokeWidth: 1.09859,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.3 3.3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112.5H141",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39 119.5H141",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39 126.5H107",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21 120C19.6739 120 18.4021 119.473 17.4645 118.536C16.5268 117.598 16 116.326 16 115C16 113.674 16.5268 112.402 17.4645 111.464C18.4021 110.527 19.6739 110 21 110C22.3261 110 23.5979 110.527 24.5355 111.464C25.4732 112.402 26 113.674 26 115C26 116.326 25.4732 117.598 24.5355 118.536C23.5979 119.473 22.3261 120 21 120ZM11 128C11 124 13.001 122 17.004 122H25C29 122 31 124 31 128C31 129.333 30.333 130 29 130H13C11.667 130 11 129.333 11 128Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreenchimentoInfosVideochamada, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preenchimento-infos-videochamada.72470575.svg";
export { ForwardRef as ReactComponent };